
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { computed } from 'vue';
import dayjs from 'dayjs';

import { createModuleContext } from '@rebuild/utils/moduleContext';

const MODULE_NAME = 'report';

function buildBaseCtx() {
	return {
		isSZ003010: false,
	};
}

const useReportCore = (options = {}) => {
    const { limit = undefined } = options;
    const { viewModule } = useModuleNavigation();

    const { report } = useModuleData();
    const isLoading = computed(() => report.loading);
    const isEmpty = computed(() => report.empty || !currentData.value.length);

    const loadData = async (params = {}) => {
        return report.refresh(params);
    };
    

    const handlePreview = value => {
        viewModule('report', value);
    };

    const currentData = computed(() => {
        let data = report.data?.rows || [];
        if (limit) {
            data = data.slice(0, limit);
        }
        return data.map(item => ({
            ...item,
            time: dayjs(item.publishDate).valueOf()
        }));
    });

    return {
        report,
        loadData,
        isLoading,
        isEmpty,
        handlePreview,
        currentData
    }
}

const { provide: provideCurrentContext, use: useCurrentContext } = createModuleContext(MODULE_NAME, buildBaseCtx);

export { useReportCore, provideCurrentContext, useCurrentContext };